import { IFinancialCockpitEltDocument } from '../../api/types'

export const getEltDocumentDisplayName = (
  document: Pick<IFinancialCockpitEltDocument, 'VersionName' | 'Version'>
): string => document.VersionName || `Version ${document.Version}`
